var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_900_2046)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.67239 6.53699L10.3288 7.44152L11.3918 7.09683L10.7344 8.00058L11.3907 8.90508L10.328 8.55908L9.67064 9.46283L9.67133 8.3453L8.60864 7.9993L9.67171 7.65461L9.67239 6.53699Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.88116 10.2608C6.63254 10.2608 5.62029 9.2486 5.62029 7.99997C5.62029 6.75135 6.63254 5.7391 7.88116 5.7391C8.27047 5.7391 8.63679 5.83757 8.9566 6.01085C8.45488 5.52016 7.76872 5.21735 7.0116 5.21735C5.47479 5.21735 4.229 6.46316 4.229 7.99994C4.229 9.53672 5.47482 10.7825 7.0116 10.7825C7.76878 10.7825 8.45491 10.4797 8.9566 9.98903C8.63679 10.1624 8.27047 10.2608 7.88116 10.2608Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_900_2046"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTr);
export default __webpack_public_path__ + "static/media/tr.84b4aafd7ff0a3685fcb465f642f4e7a.svg";
export { ForwardRef as ReactComponent };